function fadeOut( el: HTMLElement ): Promise<HTMLElement> {
    return new Promise( function( resolve ) {
        el.style.opacity = '1';

        function fade() {
            const opacity = parseFloat( el.style.opacity );

            el.style.opacity = ( opacity - +.1 ).toString();

            if ( parseFloat( el.style.opacity ) < 0 ) {
                resolve( el );
            } else {
                requestAnimationFrame( fade );
            }
        }

        fade();
    } );
}

function fadeIn( el: HTMLElement ): Promise<HTMLElement> {
    return new Promise( function( resolve ) {
        el.style.opacity = '0';

        function fade() {
            let opacity = parseFloat( el.style.opacity );

            if ( ( opacity += .1 ) > 1 ) {
                resolve( el );
            } else {
                el.style.opacity = opacity.toString();
                requestAnimationFrame( fade );
            }
        }

        fade();
    } );
}

export {
    fadeOut,
    fadeIn,
};
